import { render, staticRenderFns } from "./contact-import-page.vue?vue&type=template&id=6ea50398&"
import script from "./contact-import-page.vue?vue&type=script&lang=js&"
export * from "./contact-import-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports